import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AliwangwangOutlinedSvg from "@ant-design/icons-svg/es/asn/AliwangwangOutlined";
import AntdIcon from "../components/AntdIcon";
var AliwangwangOutlined = function AliwangwangOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AliwangwangOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AliwangwangOutlined.displayName = 'AliwangwangOutlined';
}
export default /*#__PURE__*/React.forwardRef(AliwangwangOutlined);